import { StandardSlidesContainerSt } from './StandardSlides.css';
import { MediaGalleryControls } from 'app/shared/components/MediaGallery/components/MediaSlider/components/StandardSlides/components/MediaGalleryControls/MediaGalleryControls';
import { MediaType } from 'app/shared/components/MediaGallery/utils';
import {
  BottomControlsWrapperSt,
  SlidePositionIndicatorSt,
} from 'app/shared/components/MediaGallery/components/MediaSlider/components/StandardSlides/components/MediaGalleryControls/MediaGalleryControls.css';
import Slider from 'app/shared/components/MediaGallery/components/MediaSlider/components/Slider/Slider';
import MediaSlideList from 'app/shared/components/MediaGallery/components/MediaSlider/components/StandardSlides/components/MediaSlideList/MediaSlideList';
import { Video } from '@heycar-uikit/icons';

const StandardSlides = ({
  disabled,
  offset,
  items,
  last,
  handleBackClick,
  handleNextClick,
  withBackground,
  onImageSlideClick,
}) => {
  return (
    <StandardSlidesContainerSt>
      <MediaGalleryControls
        disabled={disabled}
        offset={offset}
        handleBackClick={handleBackClick}
        last={last}
        handleNextClick={handleNextClick}
        withBackground={withBackground}
      />
      <Slider
        handleBackClick={handleBackClick}
        handleNextClick={handleNextClick}
      >
        <MediaSlideList
          items={items}
          onImageSlideClick={onImageSlideClick}
          withBackground={withBackground}
          offset={offset}
        />
      </Slider>
      {!withBackground && (
        <BottomControlsWrapperSt>
          {items[offset]?.mediaType === MediaType.VIDEO && (
            <SlidePositionIndicatorSt>
              <Video fontSize={20} />
              <span>Video</span>
            </SlidePositionIndicatorSt>
          )}
          <SlidePositionIndicatorSt>
            <span>
              {offset + 1} / {items.length}
            </span>
          </SlidePositionIndicatorSt>
        </BottomControlsWrapperSt>
      )}
    </StandardSlidesContainerSt>
  );
};

export default StandardSlides;
